import {Component} from "@angular/core";
import {OutletEntityModel} from "../outlet-entity.model";
import {OutletSearchModel} from "../outlet-search.model";
import {provideEntityModel, provideSearchModel} from "@fedeltapointofsale/data-client";
import {AbstractSearchPage} from "../../../framework/entity/search/search-page/abstract-search-page";

@Component({
    selector: "wbo-outlet-search-page",
    templateUrl: "./outlet-search-page.component.html",
    providers: [provideSearchModel(OutletSearchModel), provideEntityModel(OutletEntityModel)]
})
export class OutletSearchPageComponent extends AbstractSearchPage {
    constructor(private searchModel: OutletSearchModel) {
        super();
    }

    prepareInitialFilter(): void {
        if (this.extendedSearchParams && this.extendedSearchParams.searchParams && this.extendedSearchParams.searchParams["outletGroupId"]) {
            this.searchModel.filter["outletGroupId"] = this.extendedSearchParams.searchParams["outletGroupId"];
        }
    }
}
